// "View More" button that reveals an already-rendered-but-hidden second
// batch of product cards from the same section, instead of navigating away
// to a collection page (see featured-collection.liquid's
// `reveal_more_in_place` setting). One-shot: there's only a single extra
// batch, so the button just removes itself once revealed.
document.addEventListener('click', (event) => {
  const button = event.target.closest('[id^="ViewMore-"]');
  if (!button) return;

  const sectionId = button.id.replace('ViewMore-', '');
  const collection = document.getElementById(`collection-${sectionId}`);
  if (!collection) return;

  collection.querySelectorAll('.grid__item--view-more[hidden]').forEach((item) => {
    item.removeAttribute('hidden');
  });

  button.closest('.collection__view-all')?.remove();
});
